<script lang="ts">
export default {
    name: "PwaInstall",
    setup() {
        const { $pwa } = useNuxtApp()
        return { pwa: $pwa }
    },
    data() {
        return {
            showBanner: false,
            showFallbackInstructions: false,
        }
    },
    computed: {
        isInstalled() {
            return this.pwa?.isPWAInstalled ?? false
        },
        canInstallNatively() {
            return this.pwa?.showInstallPrompt ?? false
        },
    },
    mounted() {
        setTimeout(() => {
            if (!this.isInstalled) {
                this.showBanner = true
            }
        }, 5000)
    },
    methods: {
        async install() {
            if (this.canInstallNatively) {
                await this.pwa?.install()
                this.showBanner = false
            }
            else {
                this.showFallbackInstructions = true
            }
        },
        close() {
            this.showBanner = false
            this.showFallbackInstructions = false
        },
    },
}
</script>

<template>
    <v-snackbar
        v-model="showBanner"
        :timeout="10000"
        vertical
        elevation="24"
        rounded="lg"
        class="mb-4"
    >
        <div class="d-flex align-center">
            <v-avatar size="40" rounded="sm" color="primary" class="me-3">
                <v-icon color="white">mdi-cellphone-arrow-down</v-icon>
            </v-avatar>

            <div class="text-body-2">
                <span class="font-weight-bold d-block mb-2">Installer l'application</span>
                <template v-if="showFallbackInstructions">
                    Appuyez sur le <strong>bouton menu</strong> du navigateur, puis sur
                    <strong>"Ajouter à l'écran d'accueil"</strong>.
                </template>
                <template v-else>
                    Ajoutez SERPIC sur votre écran d'accueil pour un accès rapide.
                </template>
            </div>
        </div>

        <template v-slot:actions>
            <v-btn
                v-if="!showFallbackInstructions"
                color="primary"
                variant="flat"
                @click="install"
            >
                Installer
            </v-btn>
            <v-btn
                color="primary"
                variant="text"
                @click="close"
            >
                Fermer
            </v-btn>
        </template>
    </v-snackbar>
</template>
